import invariant from 'invariant';
import constants from './constants';
import { Tab } from './modal';
import { SignatureData } from './signature-modal-v2';
import { SigData } from '../context/signer-app-client/signature';
import { SignatureModalContext } from './signature-modal-context/context';
import { OnSignatureDataType } from './signature-modal-context/signature-provider-intercept';

export default function useInsertSignature(
  selectedTab: Tab,
  onInsert: (signatureData: SigData | null, insertEverywhere: boolean) => void,
  getSignatureData: () => SignatureData | null,
  createNewSignature: SignatureModalContext['createNewSignature'],
) {
  const insertSignature = async (insertEverywhere = false) => {
    const signatureData = getSignatureData();

    invariant(signatureData, 'Missing signatureData');

    if (selectedTab === constants.TAB_SAVED) {
      onInsert(signatureData, insertEverywhere);
    } else if (signatureData != null) {
      try {
        const data = await createNewSignature(
          signatureData as OnSignatureDataType,
        );
        onInsert(data, insertEverywhere);
      } catch (e) {
        // Errors here can be ignored because they're handled in createNewSignature
      }
    }
  };

  const insertSignatureEverywhere = () => {
    return insertSignature(true);
  };

  return { insertSignature, insertSignatureEverywhere };
}
